import React, {useState} from "react";
import { Table, Container, Pagination } from "react-bootstrap";
import { BtnBorrarDinamico, BtnBoostrapDinamico } from "../Botones";
import { ModalDinamico } from "../Modals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { FormEditEquipo } from "../Forms_Edit";
import { useDispatch, useSelector } from "react-redux";
import { DeleteEquipo } from "../../Api/Equipos.Api";
import { findName } from "../../globalFunctions";

export const TablaEquipos = ({ data }) => {
  const dataMarcas  = useSelector(state => state.Marcas.data)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const PAGE_SIZE = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastItem = currentPage * PAGE_SIZE;
  const indexOfFirstItem = indexOfLastItem - PAGE_SIZE;
  const currentData = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "800px",
        overflowY: "auto",
        marginTop: "20px",
      }}
    >
      <Table>
        <thead
          style={{
            backgroundColor: "#fed8",
            fontStyle: "italic",
            fontWeight: "bold",
            fontSize: ".8rem",
          }}
        >
          <tr>
            <td>Nº</td>
            <td>Marca</td>
            <td>Frigo</td>
            <td>Detalle</td>
            <td>Editar</td>
            <td>Borrar</td>
          </tr>
        </thead>
        <tbody>
          {currentData.map((e) => (
            <tr key={e.eq_iden}>
              <td>{e.eq_nume}</td>
              <td>{findName(dataMarcas, "ma_iden", e.ma_iden, "ma_desc")}</td>
              <td>{e.eq_frig}</td>
              <td>
                <BtnBoostrapDinamico
                  size={"sm"}
                  name={<FontAwesomeIcon icon={faEye} />}
                  click={() =>
                    navigate(
                      `/Empresa/${e.em_iden}/Planta/${e.pl_iden}/Zona/${e.zo_iden}/Sector/${e.se_iden}/Equipo/${e.eq_iden}/Intervenciones`
                    )
                  }
                />
              </td>
              <td>
                <ModalDinamico
                  size={"sm"}
                  variant={"outline-success"}
                  Body={<FormEditEquipo id={e.eq_iden} />}
                  Titulo="Editar Equipo"
                  nameBoton={<FontAwesomeIcon size="xs" icon={faPenToSquare} />}
                />
              </td>
              <td>
                <BtnBorrarDinamico
                  action={() => dispatch(DeleteEquipo(e.eq_iden))}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination style={{ display: "flex", flexWrap: "wrap" }}>
        {Array.from({ length: Math.ceil(data.length / PAGE_SIZE) }).map(
          (item, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          )
        )}
      </Pagination>
    </Container>
  );
};
